import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Image } from '../../components/HotelDescription/components/Image.js';
import { ImageContainer } from '../../components/HotelDescription/components/ImageContainer.js';
import { Info } from '../../components/HotelDescription/components/Info.js';
import { Logo } from '../../components/HotelDescription/components/Logo.js';
import { Title } from '../../components/HotelDescription/components/Title.js';
import { TourOperatorDescription } from '../../components/HotelDescription/components/TourOperatorDescription.js';
import { TourOperatorInformation } from '../../components/HotelDescription/TourOperatorInformation/index.js';
import { PictureFallback } from '../../components/PictureFallback/index.js';
import { Flex, HeadlineLarge, LabelMedium } from '../../primitives/index.js';
import { qaId } from '../../utils/index.js';
import { HOTEL_DETAILS_QA_ID } from '../../utils/qaId.js';
export const HotelDescription = ({
  organizerLogo,
  organizerName,
  hotel: {
    image,
    name,
    city,
    region,
    country,
    category,
    tourOperatorDescription,
    curatedDescription,
    categoryType
  },
  showTourOperatorInformation = false
}) => {
  const {
    t
  } = useTranslation('hotelDescription');
  return _jsxs(Flex, {
    spacing: "20px",
    children: [_jsxs(Title, {
      "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'tour-operator', 'info'),
      children: [_jsx(HeadlineLarge, {
        children: t('tourOperatorDescription')
      }), organizerLogo ? _jsx(Logo, {
        src: organizerLogo,
        alt: organizerName
      }) : _jsx(LabelMedium, {
        children: organizerName
      })]
    }), _jsxs(Flex, {
      children: [_jsxs(Flex, {
        direction: "row",
        spacing: "12px",
        "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'hotel', 'info'),
        children: [_jsx(ImageContainer, {
          children: image ? _jsx(Image, {
            src: image,
            alt: name
          }) : _jsx(PictureFallback, {
            svg: false
          })
        }), _jsx(Info
        // @ts-expect-error FIXME
        , {
          // @ts-expect-error FIXME
          rating: category,
          hotel: name,
          hotelCategoryType: categoryType,
          country: country,
          region: region,
          city: city
        })]
      }), showTourOperatorInformation &&
      // Condition added only for storybook because BE is not ready
      _jsx(TourOperatorInformation, {
        tourOperatorName: organizerName,
        value: category,
        type: categoryType,
        name: name
      }), _jsx(TourOperatorDescription, {
        tourOperatorDescription: tourOperatorDescription,
        curatedDescription: curatedDescription
      })]
    })]
  });
};